import * as React from 'react';
import styled from 'styled-components';
import { IBaseComponentProps } from '../types';
import { Typography } from '../typography';
import { selectThemeSemantics } from '../../styling';

const Text = styled(Typography.Medium).attrs({
    className: String('ap-radioButton-label')
}) <{ $disabled?: boolean; $required?: boolean; }>`
    padding-left: ${selectThemeSemantics(({ gap }) => gap.l)};
    vertical-align: middle;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
    &:after {
        content: ${({ $required }) => ($required ? '\'*\'' : '')};
        color: ${selectThemeSemantics(({ palette }) => palette.red)};
    }
`;

interface IRadioButtonLabelProps extends React.HTMLProps<HTMLLabelElement>, IBaseComponentProps<HTMLLabelElement> {
    children?: React.ReactChild;
    title?: string;
}

const RadioButtonLabelBase = React.memo((props: IRadioButtonLabelProps) => {
    const { children, required, disabled, title, ...labelProps } = props;
    return (
        <label {...labelProps} title={title}>
            <Text $required={required} $disabled={disabled}>{children}</Text>
        </label>
    );
});

RadioButtonLabelBase.displayName = 'RadioButtonLabel';

export const RadioButtonLabel = styled(RadioButtonLabelBase).attrs(() => ({
    className: String('ap-radiobutton')
}))`
    display: inline-block;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    user-select: none;
    &:before {
        box-sizing: border-box;
        content: "";
        display: inline-block;
        vertical-align: middle;
        height: 18px;
        width: 18px;
        border-width: 1px;
        border-style: solid;
        border-radius: ${({ theme: { semantics: { borderRadius } } }) => borderRadius.circle};
        border-color: ${({ theme: { radioButton: { colors } } }) => colors.default.borderColor};
        background-color: ${({ theme: { radioButton: { colors } } }) => colors.default.checkMarkColor};
    };
    &:hover {
        &:before {
            box-shadow: 0 0 0 3.5px ${({ theme: { radioButton: { colors } } }) => colors.hovered.backgroundColor} inset;
            border-color: ${({ theme: { radioButton: { colors } } }) => colors.hovered.borderColor};
        }
    }
`;
